module.exports = __webpack_public_path__ + "img/rarity4.9da58d9d.png";